import { render, staticRenderFns } from "./NodeEdit.vue?vue&type=template&id=220947e6"
import script from "./NodeEdit.vue?vue&type=script&lang=js"
export * from "./NodeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports